import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#5271ff',
        secondary: '#ffde59'
      }
    }
  }
}

export default new Vuetify(opts)
